export const state = () => ({
  ads: [],
  article: null,
  articles: [],
  author: null,
  authors: [],
  categories: [],
  category: null,
  guide: null,
  guides: [],
  meta: {},
  media: null,
  navArticles: [],
  products: [],
  pressclipping: null,
  podcasts: null
});

export const actions = {
  async getLatestPodcast ({ commit }) {
    try {
      const podcastData = await this.$api('media/pressclippings', { limit: 1, page: 1, type: 'podcasts' });
      commit('setPodcasts', podcastData);
    } catch (error) {
      console.error('Error fetching latest podcast:', error);
    }
  }
};

export const mutations = {
  clearAuthors (state) {
    state.authors = [];
  },
  setAds (state, ads) {
    state.ads = ads;
  },
  setArticle (state, article) {
    state.article = article;
  },
  setArticles (state, articles) {
    state.articles = articles;
  },
  setAuthor (state, author) {
    state.author = author;
  },
  setAuthors (state, authors) {
    state.authors = authors;
  },
  setCategories (state, categories) {
    state.categories = categories;
  },
  setCategory (state, category) {
    state.category = category;
  },
  setGuide (state, guide) {
    state.guide = guide;
  },
  setGuides (state, guides) {
    state.guides = guides;
  },
  setList (state, articles) {
    state.articles = articles;
  },
  setMedia (state, mediaList) {
    state.media = mediaList.map(media => {
      return { ...media, ...{ type: 'pressclipping' } };
    });
  },
  setNavArticles (state, articles) {
    state.navArticles = articles;
  },
  setPodcasts (state, podcastsList) {
    state.podcasts = podcastsList;
  },
  setMeta (state, meta) {
    state.meta = meta;
  },
  setPressclipping (state, clip) {
    state.pressclipping = clip;
  },
  clear (state) {
    state.articles = [];
  }
};

export const getters = {
  getAds (state) {
    return state.ads;
  },
  getArticle (state) {
    return state.article;
  },
  getAuthor (state) {
    return state.author;
  },
  getAuthors (state) {
    return state.authors;
  },
  getCategories (state) {
    return state.categories;
  },
  getCategory (state) {
    return state.category;
  },
  getGuide (state) {
    return state.guide;
  },
  getGuides (state) {
    return state.guides;
  },
  getList (state) {
    return state.articles;
  },
  getMedia (state) {
    return state.media;
  },
  getMeta (state) {
    return state.meta;
  },
  getNavArticles (state) {
    return state.navArticles;
  },
  getPressclipping (state) {
    return state.pressclipping;
  },
  getPodcasts (state) {
    return state.podcasts;
  }
};
